// src/utils/guardHelpers.js
import * as yup from 'yup';

export function getNextEmployeeCode(total, prefix = 'GUARD', pad = 3) {
  const next = (total || 0) + 1;
  return `${prefix}${String(next).padStart(pad, '0')}`;
}

export function generatePassword(length = 12) {
  const chars =
    'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789!@#$%^&*';
  let pwd = '';
  for (let i = 0; i < length; i += 1) {
    pwd += chars[Math.floor(Math.random() * chars.length)];
  }
  return pwd;
}

export function getPasswordStrength(password) {
  if (!password) {
    return {
      score: 0,
      label: '',
      colorClass: 'bg-slate-200',
      textClass: 'text-slate-400',
    };
  }

  let score = 0;
  if (password.length >= 8) score += 1;
  if (/[A-Z]/.test(password)) score += 1;
  if (/[0-9]/.test(password)) score += 1;
  if (/[^A-Za-z0-9]/.test(password)) score += 1;

  let label;
  let textClass;
  let colorClass;

  if (score <= 1) {
    label = 'Weak';
    textClass = 'text-rose-500';
    colorClass = 'bg-rose-500';
  } else if (score === 2 || score === 3) {
    label = 'Medium';
    textClass = 'text-amber-500';
    colorClass = 'bg-amber-500';
  } else {
    label = 'Strong';
    textClass = 'text-emerald-500';
    colorClass = 'bg-emerald-500';
  }

  return { score, label, textClass, colorClass };
}

export const guardSchema = yup.object({
  first_name: yup.string().required('First name is required'),
  last_name: yup.string().nullable(),
  email: yup
    .string()
    .email('Enter a valid email')
    .required('Email is required'),
  phone: yup.string().required('Phone is required'),
  username: yup.string().required('Username is required'),
  employee_code: yup.string().nullable(),
  status: yup
    .string()
    .oneOf(['active', 'inactive'])
    .required('Status is required'),
  date_of_joining: yup.string().nullable(),
  notes: yup.string().nullable(),
  // optional here; for create we enforce manually that it's required
  password: yup
    .string()
    .min(8, 'Password must be at least 8 characters')
    .nullable(),
});
